/** WARNING
 *
 * Don't write anything here (unless you are sure these api constants will only be used for this project in the workspace, and not shared if any project is added here).
 * Prefer using constant file from libs
 *
 * WARNING
 */

import { environment } from '~environments/environment';

// Micro services
export const IDENTITY_MICROSERVICE = `${environment.apiUrl}/identity/v1/rest`;
export const COLLECTOR_MICROSERVICE = `${environment.apiUrl}/collector/v1/rest`;
export const PRODUCT_CATALOG_MICROSERVICE = `${environment.apiUrl}/product-catalog/v1/rest`;

// User
export const LOGOUT_URL = `${environment.apiUrl}/identity/logout`;
export const PROFILE_URL = `${IDENTITY_MICROSERVICE}/me`;
export const UPDATE_USER_EMAIL_URL = `${PROFILE_URL}/fields/email/update/request`;
export const TOKENS_URL = `${IDENTITY_MICROSERVICE}/auth/tokens`;
export const OTP_URL = `${IDENTITY_MICROSERVICE}/otps`;
export const PREFERENCES_URL = `${PROFILE_URL}/preference`;

// UnitOfMeasure
export const UNIT_MEASURE_URL = `${PRODUCT_CATALOG_MICROSERVICE}/unit-of-measures`;

//Product
export const PRODUCT_URL = `${PRODUCT_CATALOG_MICROSERVICE}/products`;
